/* eslint-disable */
import { memo } from 'react';
import * as S1 from './Section.styled';
import { accountSettingsAPI } from 'services/accountSettings.service';
import { useSelector } from 'react-redux';
import { useFormContext, Controller } from 'react-hook-form';
import { Upload, CustomTooltip, CustomInput } from 'components';
import { Question } from 'assets/icons';
import { requireRules, websiteValidationRules, phoneValidationRules } from './validation';

const inputWidth = 285;

export const CompanySection = memo(() => {
  const {
    formState: { errors },
    setValue,
    watch,
    control,
  } = useFormContext();

  const getValue = (field) => {
    return watch(`companyInformation.${field}`) || '';
  };
  const accountSettingsData = useSelector(
    (state) => accountSettingsAPI.endpoints.GetAccountSettingsData.select()(state)?.data,
  );

  const handleFileChange = (file) => {
    setValue('companyInformation.profileImage', file, { shouldDirty: true });
    setValue('companyInformation.profileImageUrl', null, { shouldDirty: true });
  };
  const handleIdOrCertificateFileChange = (file) => {
    setValue('companyInformation.idOrCertificateImage', file, { shouldDirty: true });
    setValue('companyInformation.idOrCertificateImageUrl', null, { shouldDirty: true });
  };

  const handleChangeFieldValue = (field, value) => {
    setValue(`companyInformation.${field}`, value, { shouldDirty: true });
  };

  return (
    <div>
      <S1.TextBox>
        <S1.AdditionalText isBottom>
          Appnext is a monetization platform as well as a community for discussing ideas, creating
          relationship and growing your app business.
          <br /> Fill in more details to get Appnext community to notice you, engage with you,
          promote your business and partner with you.
        </S1.AdditionalText>
      </S1.TextBox>
      <S1.SectionBox>
        <S1.Row isStart>
          <div>
            <S1.FieldName>Profile Image</S1.FieldName>
            {/* <S1.SubField>
                Requirements
                <CustomTooltip
                  style={{ marginLeft: '4px' }}
                  content={<Question />}
                  text={
                    <p style={{ maxWidth: '150px' }}>
                      Appnext is a monetization platform as well as a community for discussing ideas,
                      creating relationship and growing your app business.
                    </p>
                  }
                />
              </S1.SubField> */}
          </div>
          <div style={{ width: '160px' }}>
            <Upload
              accept='image/jpeg, image/jpg, image/png, image/gif'
              value={getValue('profileImageUrl')}
              id='file'
              size={Upload.Size?.Big}
              onChange={handleFileChange}
              buttonText='Choose File'
              environment='accountSettings'
            />
          </div>
        </S1.Row>
        <S1.Row>
          <S1.FieldName isRequired>Company</S1.FieldName>
          <Controller
            rules={requireRules}
            name='companyInformation.company'
            control={control}
            render={({ field, fieldState, formState }) => {
              const { name, onChange, value } = field;
              const { invalid } = fieldState;
              return (
                <CustomInput
                  value={value}
                  autoComplete='off'
                  id={name}
                  name={name}
                  error={invalid}
                  onChange={onChange}
                  width={inputWidth}
                />
              );
            }}
          />
        </S1.Row>
        <S1.Row>
          <S1.FieldName isRequired>Street Address</S1.FieldName>
          <Controller
            rules={requireRules}
            name='companyInformation.streetAddress'
            control={control}
            render={({ field, fieldState, formState }) => {
              const { name, onChange, value } = field;
              const { invalid } = fieldState;
              return (
                <CustomInput
                  value={value}
                  autoComplete='off'
                  id={name}
                  name={name}
                  error={invalid}
                  onChange={onChange}
                  width={inputWidth}
                />
              );
            }}
          />
        </S1.Row>
        <S1.Row>
          <S1.FieldName>City</S1.FieldName>
          <CustomInput
            value={getValue('city')}
            autoComplete='off'
            id='city'
            name='city'
            onChange={(e) => {
              handleChangeFieldValue('city', e.target.value);
            }}
            width={inputWidth}
          />
        </S1.Row>
        <S1.Row>
          <S1.FieldName>State</S1.FieldName>
          <CustomInput
            value={getValue('state')}
            autoComplete='off'
            id='state'
            name='state'
            onChange={(e) => {
              handleChangeFieldValue('state', e.target.value);
            }}
            width={inputWidth}
          />
        </S1.Row>
        <S1.Row>
          <S1.FieldName>Postal Code</S1.FieldName>
          <CustomInput
            value={getValue('postalCode')}
            autoComplete='off'
            id='postalCode'
            name='postalCode'
            onChange={(e) => {
              handleChangeFieldValue('postalCode', e.target.value);
            }}
            width={inputWidth}
          />
        </S1.Row>
        <S1.Row>
          <S1.FieldName isRequired>Country</S1.FieldName>
          <Controller
            rules={requireRules}
            name='companyInformation.country'
            control={control}
            render={({ field, fieldState, formState }) => {
              const { name, onChange, value } = field;
              const { invalid } = fieldState;
              return (
                <CustomInput
                  value={value}
                  autoComplete='off'
                  id={name}
                  name={name}
                  error={invalid}
                  onChange={onChange}
                  width={inputWidth}
                />
              );
            }}
          />
        </S1.Row>
        <S1.PhoneRow
          style={{ marginBottom: errors.companyInformation?.phoneNumber ? '16px' : '0' }}
        >
          <S1.FieldName>Phone number</S1.FieldName>
          <S1.PhoneInputWrap>
            <Controller
              name='companyInformation.phoneNumber'
              rules={phoneValidationRules}
              control={control}
              render={({ field, fieldState, formState }) => {
                const { name, onChange, value } = field;
                const { invalid } = fieldState;
                return (
                  <CustomInput
                    type='text'
                    value={value}
                    autoComplete='off'
                    id={name}
                    name={name}
                    error={invalid}
                    errorText={'Please enter a valid phone number'}
                    onChange={(e) => {
                      const onlyNums = e.target.value.replace(/\D/g, ''); // remove non-digits
                      onChange(onlyNums);
                    }}
                    width={inputWidth}
                  />
                );
              }}
            />
          </S1.PhoneInputWrap>
        </S1.PhoneRow>
        <S1.Row>
          <S1.FieldName>Website</S1.FieldName>
          <Controller
            rules={websiteValidationRules}
            name='companyInformation.additionalInfo.website'
            control={control}
            render={({ field, fieldState, formState }) => {
              const { name, onChange, value } = field;
              const { invalid } = fieldState;
              return (
                <CustomInput
                  value={value}
                  autoComplete='off'
                  id={name}
                  name={name}
                  onChange={onChange}
                  width={inputWidth}
                  error={invalid}
                />
              );
            }}
          />
        </S1.Row>
        <S1.Row isStart>
          <div>
            <S1.FieldName>ID or Company</S1.FieldName>
            <S1.FieldName>reg certificate</S1.FieldName>
            {/* <S1.SubField>
                Requirements
                <CustomTooltip
                  style={{ marginLeft: '4px' }}
                  content={<Question />}
                  text={
                    <p style={{ maxWidth: '150px' }}>
                      Appnext is a monetization platform as well as a community for discussing ideas,
                      creating relationship and growing your app business.
                    </p>
                  }
                />
              </S1.SubField> */}
          </div>
          <div style={{ width: '160px' }}>
            <Upload
              accept='image/jpeg,image/jpg,image/png,image/gif,application/pdf'
              value={getValue('idOrCertificateImageUrl')}
              id='file'
              size={Upload.Size?.Big}
              onChange={handleIdOrCertificateFileChange}
              buttonText='Choose File'
              environment='accountSettings'
            />
          </div>
        </S1.Row>
      </S1.SectionBox>
    </div>
  );
});
